import axios from 'axios'

/**
 * 모바일 환경 감지 (화면 너비 기준)
 */
const isMobile = () => {
	return typeof window !== 'undefined' && window.innerWidth < 480
}

export async function certificateNice(returnUrl, popupName = 'nicePopup') {
	const option = `width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no`
	const parsedReturnUrl = encodeURIComponent(returnUrl) // 본인인증 결과를 전달받을 api url

	console.log('returnUrl' + returnUrl)

	// token api가 요청 데이터를 암호화한 후 표준창 호출에 필요한 데이터를 응답해준다.
	try {
		const response = await axios.get(
			`${process.env.REACT_APP_API_ENDPOINT}/users/niceapi/token/${parsedReturnUrl}`,
		)
		const result = response.data

		if (result.success === false) throw result

		if (result) {
			console.log('서버로부터 토큰 받기 성공!')
			const { tokenVersionId, encData, integrityValue } = result
			console.log('result:', result)

			// dynamically build and submit form
			const dynamicForm = document.createElement('form')
			dynamicForm.method = 'post'
			dynamicForm.action = 'https://nice.checkplus.co.kr/CheckPlusSafeModel/service.cb'
			dynamicForm.style.display = 'none'

			// helper to create hidden inputs
			const createHiddenInput = (name, value) => {
				const input = document.createElement('input')
				input.type = 'hidden'
				input.name = name
				input.value = value
				return input
			}

			dynamicForm.appendChild(createHiddenInput('m', 'service'))
			dynamicForm.appendChild(createHiddenInput('token_version_id', tokenVersionId))
			dynamicForm.appendChild(createHiddenInput('enc_data', encData))
			dynamicForm.appendChild(createHiddenInput('integrity_value', integrityValue))
			dynamicForm.appendChild(createHiddenInput('ReturnURL', returnUrl))

			document.body.appendChild(dynamicForm)

			// 모바일 환경: 팝업 없이 현재 페이지에서 직접 submit
			if (isMobile()) {
				console.log('모바일 환경: 현재 페이지에서 직접 submit')
				dynamicForm.submit()
				// 폼 제출 후 정리 (submit 후 페이지가 이동하므로 제거는 선택적)
				// document.body.removeChild(dynamicForm)
				return null // 모바일에서는 popup 반환하지 않음
			} else {
				// 웹 환경: 팝업으로 열기
				console.log('웹 환경: 팝업으로 열기')
				dynamicForm.target = popupName
				const popup = window.open('', popupName, option)
				dynamicForm.submit()
				document.body.removeChild(dynamicForm)
				return popup
			}
		}
	} catch (error) {
		console.error('본인인증 요청 중 오류 발생:', error)
	}
}
